import socSimulator from 'src/images/pngs/business/altert-queue.png';
import managementDashboard from 'src/images/pngs/business/management-dashboard.png';
import threatHuntingSimulator from 'src/images/pngs/business/threat-hunting.png';
import tabletopExercises from 'src/images/pngs/business/ttx.png';
export const productCarouselCards = [
  {
    image: socSimulator,
    name: 'SOC Simulator',
    description: 'Immersive triage training built around real attacks.',
  },
  {
    image: managementDashboard,
    name: 'Management Dashboard',
    description: 'All your team management and training, simplified in one place.',
  },
  {
    image: threatHuntingSimulator,
    name: 'Threat Hunting Simulator',
    description: 'Hands-on threat hunts to train attacker-style thinking.',
  },
  {
    image: tabletopExercises,
    name: 'Tabletop Exercises',
    description: 'AI-guided tabletop exercises for real-world preparedness.',
  },
];

export const sliderSettings = {
  className: 'center',
  dots: false,
  infinite: true,
  speed: 600,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerMode: true,
  centerPadding: '30%',
  initialSlide: 0,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  swipe: true,
  draggable: true,
  touchMove: true,
  accessibility: false,
  responsive: [
    {
      breakpoint: 1900,
      settings: {
        slidesToShow: 1,
        centerPadding: '25%',
      },
    },
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 1,
        centerPadding: '20%',
      },
    },
    {
      breakpoint: 1400,
      settings: {
        slidesToShow: 1,
        centerPadding: '18%',
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
      },
    },
  ],
};
